/**
 * Created by qlong on 9/9/2016.
 */
import { createStore } from 'redux'
import reducer from './reducers'

export default createStore(reducer, window.devToolsExtension && window.devToolsExtension())



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/